// ================================================================
// PROPRIETARY & CONFIDENTIAL — Miskulin Technologies Inc.
// PhoneInput — Auto-formatting phone number input (US/CA)
// Formats: (403) 555-1234 as user types
// ================================================================
import React, { useCallback } from 'react';

function formatPhone(raw) {
  // Strip to digits only
  const digits = raw.replace(/\D/g, '');
  // Remove leading '1' country code if present
  const d = digits.startsWith('1') && digits.length > 10 ? digits.slice(1) : digits;

  if (d.length === 0) return '';
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6, 10)}`;
}

function unformatPhone(formatted) {
  return formatted.replace(/\D/g, '').slice(0, 10);
}

/**
 * PhoneInput
 *
 * Props:
 *   value      — raw or formatted phone string
 *   onChange   — (formattedValue, rawDigits) => void
 *   className  — CSS class (default: 'input')
 *   placeholder
 *   disabled
 *   id
 */
export default function PhoneInput({
  value = '',
  onChange,
  className = 'input',
  placeholder = '(403) 555-1234',
  disabled = false,
  id,
  style,
  ...rest
}) {
  const handleChange = useCallback((e) => {
    const raw = unformatPhone(e.target.value);
    const formatted = formatPhone(e.target.value);
    if (onChange) onChange(formatted, raw);
  }, [onChange]);

  return (
    <input
      id={id}
      type="tel"
      className={className}
      value={formatPhone(value)}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      style={style}
      inputMode="tel"
      maxLength={14}
      {...rest}
    />
  );
}

export { formatPhone, unformatPhone };
